<app-loader *ngIf="userAccessLoading$ | async"></app-loader>
<form
  *ngIf="userAccess"
  [formGroup]="studentAccessForm"
  (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <div class="d-flex justify-content-between">
      <app-date-picker
        class="w-50 mb-3"
        formControlName="start_date"
        label="Дата начала"
        hint="ДД.ММ.ГГГГ"
        [appearance]="'outline'"
        [formGroup]="studentAccessForm"
        [max]="end_date && end_date.value"
        [control]="start_date"
        [datePicker]="start_date"
        [errorFromApi]="
          errors$ && errors$.start_date ? errors$.start_date[0] : null
        "
        [requiredErrorMessage]="
          'Дата начала не может быть позже даты окончания'
        "></app-date-picker>

      <mat-form-field class="w-25 mb-3" appearance="outline">
        <input
          placeholder="Время начала"
          required
          matInput
          type="time"
          formControlName="start_time"
          [errorStateMatcher]="matcher" />
        <mat-hint>ЧЧ:MM</mat-hint>
      </mat-form-field>
    </div>
    <hr />
    <div class="d-flex justify-content-between">
      <app-date-picker
        class="w-50 mb-3"
        formControlName="end_date"
        label="Дата начала"
        hint="ДД.ММ.ГГГГ"
        [appearance]="'outline'"
        [formGroup]="studentAccessForm"
        [min]="start_date && start_date.value"
        [control]="end_date"
        [datePicker]="end_date"
        [errorFromApi]="
          errors$ && errors$.end_date ? errors$.end_date[0] : null
        "
        [requiredErrorMessage]="
          'Дата окончания не может быть раньше даты начала'
        "></app-date-picker>

      <mat-form-field class="w-25 mb-3" appearance="outline">
        <input
          placeholder="Время окочания"
          required
          matInput
          type="time"
          formControlName="end_time" />
        <mat-hint>ЧЧ:MM</mat-hint>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <div mat-dialog-actions class="justify-content-end">
    <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
      Отмена
    </button>
    <app-button-with-progress
      typeBtn="submit"
      label="Сохранить"
      [loading$]="sendLoading$ | async"
      [isDisabled]="isDisabled()"></app-button-with-progress>
  </div>
</form>
